import React from "react";
import "./solution.css";
import pointerIcon1 from "../../../images/Agent Trust Images/assets/SolutionSection/Vulnerability Report.svg";
import pointerIcon2 from "../../../images/Agent Trust Images/assets/SolutionSection/Advanced Vulnerability Detection.svg";
import pointerIcon3 from "../../../images/Agent Trust Images/assets/SolutionSection/Compliance Assurance.svg";
import pointerIcon4 from "../../../images/Agent Trust Images/assets/SolutionSection/User-Friendly Dashboard.svg";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";
export default function Solution() {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });
  const solutionPoints = [
    {
      heading: "Vulnerability Report",
      paragraph:
        "Analyses AI models for biases, security risks, and ethical concerns, providing actionable insights to mitigate vulnerabilities.",
      icon: pointerIcon1,
    },
    {
      heading: "Advanced Vulnerability Detection",
      paragraph:
        "Identifies weaknesses in AI decision-making processes and ensures proactive risk mitigation for secure AI deployment.",
      icon: pointerIcon2,
    },
    {
      heading: "Compliance Assurance",
      paragraph:
        "Automates AI compliance checks, ensuring alignment with GDPR, HIPAA, ISO 27001, and industry-specific regulations.",
      icon: pointerIcon3,
    },
    {
      heading: "User-Friendly Dashboard",
      paragraph:
        "Provides an intuitive interface for monitoring AI trust scores, security risks, and compliance status, enabling easy management.",
      icon: pointerIcon4,
    },
  ];

  return (
    <section
      className={`solution-section ${isVisible ? "section-animation" : ""}`}
      ref={ref}
      id="two"
    >
      <div className="container">
        <div className="section-heading">
          <div className="heading-tag">
            <span>Solution</span>
          </div>
          <div className="heading-description">
            <h2>
              Ensuring AI Excellence: AI-Driven Trust Scoring for Reliable and
              Transparent AI Systems
            </h2>
            <p>
              Unlock AI-powered trust evaluation solutions that enhance
              transparency, security, and compliance across AI-driven
              operations.
            </p>
          </div>
        </div>
        <div className="solution-section-content">
          <div className="solution-cards-wrapper row">
            {solutionPoints.map((point, index) => (
              <div className="col-12 col-sm-6" key={index}>
                <div
                  className={`solution-point-inner ${
                    index === 0 || index === 3 ? "yellow-card" : "blue-card"
                  } `}
                >
                  <img src={point.icon} alt="pointer-icon" />
                  <div>
                    <h3>{point.heading}</h3>
                    <p>{point.paragraph}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
